module.exports = __webpack_public_path__ + "static/turtcenter-5ef9265d45ffc4fe368fc34bcbb7e113.png";